import { SocketTopics } from "@shared/types";
import {
  GetTopicDataFunc,
  SocketTradeIdArgs,
  SocketTradeIdState,
  TopicReducerHandler,
} from "@shared/services/socket/types";
import { isSymbol } from "@shared/types/utils";
import { transformSocketData } from "@shared/features/trades/common/tradeExtraDetailsTransforms";

export class TradeExtraDetailsHandler
  implements TopicReducerHandler<SocketTopics.TRADE_EXTRA_DETAILS>
{
  private tradeId: number | undefined = undefined;

  add({ tradeId }: SocketTradeIdArgs): boolean {
    const shouldUpdate = this.tradeId !== tradeId;
    this.tradeId = tradeId;
    return shouldUpdate;
  }

  remove(_args: SocketTradeIdArgs): [boolean, boolean] {
    this.tradeId = undefined;
    return [false, true];
  }

  getState = (): SocketTradeIdState => {
    return { trade_id: this.tradeId };
  };

  getData: GetTopicDataFunc<SocketTopics.TRADE_EXTRA_DETAILS> = (
    args,
    data
  ) => {
    if (isSymbol(args) || !data) return;
    const { tradeId } = args as SocketTradeIdArgs;
    if (data.original_trade_id !== tradeId) return;
    return {
      ...data,
      data: transformSocketData(data.data),
    };
  };
}
